<script setup>
import "@/assets/new-style/all.css";
import "@/assets/new-style/uikit.css";
</script>

<template>
  <footer class="footer">
    <div class="footer-filling footer-filling--desk container">
      <span class="footer-info">При поддержке:</span>
    </div>
    <div class="footer-filling container">
      <div class="footer-left">
        <router-link :to="{name: 'RedesignLandingPage'}" href="#" class="logo">
          <img src="@/assets/new-icons/logo.svg" alt="Лого" class="logo" />
        </router-link>
        <a href="#" class="tg" target="_blank" v-if="false">
          <img src="@/assets/new-icons/tg.svg" alt="" class="tg__icon" />
        </a>
      </div>
      <div class="politic" v-if="false">
        <p class="politic__link">
          Политика в отношении обработки
          <a href="/metamsk-politic.pdf" target="_blank" class="politic__link">
            персональных данных</a
          >
        </p>
        <p class="politic__link">
          <a
            href="/consent_to_the_processing_of_personal_data.pdf"
            target="_blank"
            >Соглашение о пользовании
          </a>
          информационными системами и ресурсами города Москвы
        </p>
      </div>
      <div class="footer-filling footer-filling--mob container">
        <span class="footer-info footer-info">При поддержке:</span>
      </div>
      <div class="partners">
        <a
          href="https://www.mos.ru/dit/?past=N"
          target="_blank"
          class="partners-element partners-element--dep">
          <img
            src="@/assets/new-icons/footer-dep.svg"
            alt=""
            class="partners-element__icon" />
        </a>
        <a
          href="https://www.mos.ru/"
          target="_blank"
          class="partners-element partners-element--msc">
          <img
            src="@/assets/new-icons/footer-msc.png"
            alt=""
            class="partners-element__icon partners-element__icon--msc partners-element__icon" />
        </a>
        <a
          href="https://xn--h1aax.xn--p1ai/"
          target="_blank"
          class="partners-element partners-element--iri"
          v-if="$route.name !== 'FireworkPage'">
          <img
            src="@/assets/new-icons/footer-iri.svg"
            alt=""
            class="partners-element__icon partners-element__icon--iri" />
        </a>
        <a
          href="https://cgamos.ru/"
          target="_blank"
          class="partners-element"
          v-else>
          <img
            src="@/assets/new-icons/archive.png"
            alt=""
            class="partners-element__icon partners-element__icon--arc" />
        </a>
        <a
          href="https://vdnh.ru/"
          target="_blank"
          class="partners-element partners-element--vdnx">
          <img
            src="@/assets/new-icons/vdnx.svg"
            alt=""
            class="partners-element__icon partners-element__icon--vdnx" />
        </a>
      </div>
    </div>
  </footer>
</template>

<style lang="scss" scoped>
.footer {
  margin-top: auto;
  padding: 1.5rem 0;

  &-filling {
    display: flex;
    align-items: center;
    gap: 1.5rem;

    &--mob {
      display: none;
    }
  }

  &-left {
    display: flex;
    align-items: center;
    gap: 1.5rem;
  }

  &-info {
    display: block;
    margin-left: auto;
    margin-bottom: 10px;
    font-size: 1rem;
    line-height: 125%;
    color: #8f8f8f;
  }

  .logo {
    width: 8.5rem;
  }

  .tg {
    border-radius: 100%;
    background: #d72d41;
    width: 2rem;
    height: 2rem;

    &__icon {
      width: 100%;
      height: 100%;
    }
  }

  .politic {
    margin-left: auto;
    display: flex;
    flex-direction: column;
    gap: 0.625rem;

    &__link {
      font-size: 0.875rem;
      line-height: 114%;
      color: #4f4f4f;
      text-align: right;

      a {
        color: #00288c;
      }
    }
  }

  .partners {
    margin-left: auto;
    display: flex;
    gap: 1rem;
    align-items: center;
    flex-wrap: nowrap;

    &-element {
      &__icon {
        height: 3.25rem;
        display: flex;

        &--mob {
          display: none;
        }
        &--arc {
          height: 2.5rem;
          object-fit: contain;
        }

        &--iri {
          height: 1.5rem;
        }

        &--vdnx {
          height: 2rem;
        }
      }
    }
  }

  @media (max-width: 1100px) {
    margin-top: auto;
    padding: 1.5rem 0 3rem 0;

    &-filling {
      flex-direction: column;
      align-items: unset;
      gap: 1rem;
      padding: 0;

      &--desk {
        display: none;
      }

      &--mob {
        display: flex;
      }
    }

    &-info {
      margin: 0 0 0 1rem;
    }

    &-left {
      display: flex;
      align-items: center;
      gap: 1.5rem;
      padding: 0 1rem;
    }

    .logo {
      margin-bottom: -0.1rem;
    }

    .politic {
      gap: 0.75rem;
      padding: 0 1rem;

      &__link {
        font-size: 0.88rem;
        line-height: 130%;
      }
    }

    .privacy {
      margin-top: 1.5rem;
      padding: 0.875rem 1rem 1.625rem 1rem;
      display: flex;
      justify-content: center;
      gap: 0.3125rem;
      backdrop-filter: blur(59.79999923706055px);
      box-shadow: 0 -0px 0 0 #404042;
      background: rgba(81, 81, 81, 0.82);

      &__text {
        font-size: 0.75rem;
        line-height: 100%;
        letter-spacing: -0.01em;
        color: rgba(255, 255, 255, 0.8);
      }

      &__icon {
        width: 0.375rem;
      }
    }

    .partners {
      margin-left: 0;
      padding: 0 1rem;
      justify-content: space-between;
      flex-wrap: nowrap;
      gap: 1rem;

      &-element {
        background: #fff;
        max-width: 25%;

        &--msc {
          @media (max-width: 767px) {
            .partners-element__icon {
              height: 35px;
              max-height: 35px;
            }
          }
        }

        &--dep {
          @media (max-width: 767px) {
            .partners-element__icon {
              height: 35px;
              max-height: 35px;
            }
          }
        }

        &--vdnx {
          @media (max-width: 767px) {
            .partners-element__icon {
              height: 35px;
              max-height: 35px;
            }
          }
        }

        &__icon {
          &--vdnx {
            @media (max-width: 767px) {
              height: 35px;
            }
          }

          &--mob {
            display: none;
          }

          &--desk {
            display: flex;
          }
        }
      }
    }
  }
}
</style>
